import Vue from 'vue';

// @ts-ignore
export const setAll = (state, all) => {
  state.all = all;
};

// @ts-ignore
export const setOne = (state, one) => {
  state.one = one;
};

// @ts-ignore
export const setNewArticle = (state, newArticle) => {
  state.newArticle = newArticle;
};

// @ts-ignore
export const setClickedBy = (state, {article, clickedBy}) => {
  Vue.set(state.clickedBy, article.id, clickedBy);
};
